import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import firebase from "./config/firebaseConf";
import { createStore, compose, applyMiddleware } from "redux";
import { Provider } from "react-redux";
import { ReactReduxFirebaseProvider, getFirebase } from "react-redux-firebase";
import thunk from "redux-thunk";
import rootReducer from "./redux/reducers/rootReducer";
import AuthIsLoaded from "./components/auth/AuthIsLoaded";
import rrfProps from "./config/reactReduxFirebaseConf";
import {loadState, saveSate} from "./config/localStorage";
import "./App.scss";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

let storeMiddelware = compose(applyMiddleware(thunk.withExtraArgument({ getFirebase })));
if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
  storeMiddelware = composeEnhancers(applyMiddleware(thunk.withExtraArgument({ getFirebase })));
}
const store = createStore(
  rootReducer,
  loadState(),
  storeMiddelware
);

store.subscribe(()=>{
  saveSate(store.getState());
})
ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <ReactReduxFirebaseProvider {...rrfProps(firebase, store)}>
        <AuthIsLoaded>
          <App />
        </AuthIsLoaded>
      </ReactReduxFirebaseProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
